module.exports = __webpack_public_path__ + "img/white_phone.6b4e45bf.svg";